let phoneCall = function() {
  window.gtag();
  // console.log('phone test success');
}

module.exports = phoneCall;